<template>
    <div class="flex justify-center">
        <div class="w-80 h-20">
            <label
                :for="fieldName"
                class="block text-gray-700 text-sm font-bold mb-1"
                :class="[hiddenFieldName ? 'hidden' : 'block']"
            >
                {{ fieldName }}
                <span v-show="isRequired" class="text-primary-emphasis">*</span>
            </label>
            <div v-if="disabled" class="py-2 px-3">
                <span>{{ name }}</span>
            </div>
            <label v-else :for="fieldName">
                <select
                    v-model="field"
                    :name="fieldName"
                    class="form-select appearance-none block w-full h-10 text-sm rounded transition ease-in-out shadow border py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-0"
                    :class="[hiddenFieldName ? '' : 'mb-3']"
                    aria-label="Default select example"
                >
                    <option
                        v-for="item in list"
                        :key="item.value"
                        :value="item.value"
                        class="my-1"
                    >
                        {{ item.name }}
                    </option>
                </select>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectComponent",
    model: {
        prop: "valueCurrent",
        event: "change"
    },
    props: {
        hiddenFieldName: {
            type: Boolean,
            default: () => false,
            required: false
        },
        fieldName: {
            type: String,
            default: () => "fieldName",
            required: true
        },
        placeholder: {
            type: String,
            default: () => "",
            required: false
        },
        valueCurrent: {
            type: String,
            default: () => "",
            required: true
        },
        list: {
            type: Array,
            default: () => [
                {
                    value: "",
                    name: ""
                }
            ],
            required: true
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: () => false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: () => false
        }
    },
    emits: ["blur", "change"],
    data: () => ({
        field: "",
        name: ""
    }),
    watch: {
        field(value) {
            const aux = this.list.find((item) => item.value === value);
            if (aux) {
                this.name = aux.name;
                this.$emit("change", value);
            }
        },
        valueCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(`${this.valueCurrent}`);
    },
    methods: {
        setInput(value) {
            this.field = value;
        }
    }
};
</script>
